import SelectAllCheckbox from './selectAllCheckbox';
import selectAllCheckboxLabeled from './selectAllCheckboxLabeled';
import ggSwitch from './ggSwitch';
import nouislider from './nouislider';
import Permission from './permission';
import Tabs from './tabs';
import ValidationDirectives from './validationDirectives';
import FieldWrapper from './fieldWrapper';
import {checkHttpsAndWrapUrlsInCorsProxy} from '../common/util/url-util';

export default angular.module('app.directives', [
  SelectAllCheckbox.name,
  selectAllCheckboxLabeled.name,
  ggSwitch.name,
  nouislider.name,
  Permission.name,
  Tabs.name,
  ValidationDirectives.name,
  FieldWrapper.name,
  'ui.router'
])
  .directive('uiSrefActiveMatch', function($state, $stateParams, $interpolate){
    return  {
      restrict: 'A',
      controller: function($scope, $element, $attrs) {
        let activeClass;

        activeClass = $interpolate($attrs.uiSrefActiveEq || $attrs.uiSrefActive || 'is-active', false)($scope);

        $scope.$on('$stateChangeSuccess', update);

        // Update route state
        function update() {
          if (isMatch()) {
            $element.addClass(activeClass);
          } else {
            $element.removeClass(activeClass);
          }
        }

        function isMatch() {
          return (new RegExp($attrs.uiSrefActiveMatch)).test($state.$current.self.name);
        }
      }
    };
  })
  .directive('multipleRequired', function() {
    return {
      restrict: 'A',
      require: 'ngModel',
      link: function (scope, element, attrs, ngModel) {
        if (attrs.multipleRequired) {
          ngModel.$validators.multipleRequired = function(modelValue, viewValue) {
            return !!(modelValue || viewValue).length
          }
        }
      }
    };
  })
  .directive('ggIcon', function() {
    return {
      restrict: 'A',
      scope: {
        ggIcon: '@',
        tooltip: '@',
        innerText: '@'
      },
      template: `<svg role="img" class="o-icon {{iconSize}} {{iconClass}}">
                  <use ng-attr-href="{{::iconHref | trustUrl}}" ng-attr-xlink:href="{{::iconHref | trustUrl}}"></use>
                </svg>
                {{ ::innerText }}`,
      link: function (scope, element, attrs, ngModel) {
        let [icon, size, iconClass] = scope.ggIcon.split(':');
        scope.iconHref = '#' + icon;
        if (!_.isEmpty(size)) {
          scope.iconSize = 'o-icon--' + size;
        }
        if (!_.isEmpty(iconClass)) {
          scope.iconClass = iconClass;
        }

        if (scope.tooltip) {
          element.addClass('has-tooltip');
          let tooltipSize = scope.tooltip.length > 30 ? 'c-tooltip--large' : 'c-tooltip--small';
          element.append(`<span class="c-tooltip c-tooltip--top z-500 ${tooltipSize} " data-title="${scope.tooltip}"></span>`);
        }
      }
    };
  })
  .directive('ggRefreshIcon', function($timeout) {
    return {
      restrict: 'A',
      scope: {
        ggRefreshIcon: '@',
        tooltip: '@',
        innerText: '@',
        action: '&'
      },
      template: `<svg ng-if="!showLoader" role="img" ng-click="refresh()" class="o-icon {{iconSize}} {{iconClass}}">
                  <use xlink:href="#refresh"></use>
                </svg>
                <img ng-if="showLoader" class="o-icon--large" ng-src="images/loading.svg"">
                {{ innerText }}`,
      link: function (scope, element, attrs, ngModel) {
        scope.refresh = () => {
          !scope.preventRefresh && scope.action();
          scope.preventRefresh = true;
          scope.showLoader = true;
          $timeout(() => { scope.preventRefresh = false; }, 5000);
          $timeout(() => { scope.showLoader = false; }, 1500);
        };
        let [size, iconClass] = scope.ggRefreshIcon.split(':');
        if (!_.isEmpty(size)) {
          scope.iconSize = 'o-icon--' + size;
        }
        if (!_.isEmpty(iconClass)) {
          scope.iconClass = iconClass;
        }

        if (scope.tooltip) {
          element.addClass('has-tooltip');
          let tooltipSize = scope.tooltip.length > 30 ? 'c-tooltip--large' : 'c-tooltip--small';
          element.append(`<span class="c-tooltip c-tooltip--top z-500 ${tooltipSize} " data-title="${scope.tooltip}"></span>`);
        }
      }
    };
  })
  .directive('ggBundleInfoIcon', function(corsProxy) {
    return {
      restrict: 'A',
      scope: {
        ggBundleInfoIcon: '@',
        data: '=',
        innerText: '@'
      },
      template: `<svg ng-if="data" role="img" class="o-icon {{::iconSize}} {{::iconClass}}">
                  <use ng-attr-href="{{::iconHref | trustUrl}}" ng-attr-xlink:href="{{::iconHref | trustUrl}}"></use>
                </svg>
                {{ ::innerText }}`,
      link: function (scope, element) {
        let [icon, size, iconClass] = scope.ggBundleInfoIcon.split(':');
        scope.iconHref = '#' + icon;
        if (!_.isEmpty(size)) {
          scope.iconSize = 'o-icon--' + size;
        }
        if (!_.isEmpty(iconClass)) {
          scope.iconClass = iconClass;
        }

        if(scope.data) {
          let ratingPercent = scope.data.rating ? scope.data.rating / 5 * 100 : 0;
          let genres = scope.data.genres_list ? scope.data.genres_list.replace(/;/g, ", ") : '';
          scope.data.icon = checkHttpsAndWrapUrlsInCorsProxy(scope.data.icon, corsProxy.getProxyPrefix());

          element.addClass('has-tooltip');
          element.append(`
          <div class="c-tooltip c-tooltip--top z-500 bundle-info-tt">
            <div class="icon-and-rating">
              <img class="c-thumbnail" src="${scope.data.icon}" style="min-width: 100%;">
              <div class="rating">
                <div class="star-ratings-css">
                  <div class="star-ratings-css-top" style="width: ${ratingPercent}%"><span>★</span><span>★</span><span>★</span><span>★</span><span>★</span></div>
                  <div class="star-ratings-css-bottom"><span>★</span><span>★</span><span>★</span><span>★</span><span>★</span></div>
                </div>
              </div>
            </div>
            <div class="info u-ml-">
              <div class="u-mb-">
                <a class="c-btn--secondary__header" target="_blank" href="${scope.data.link}">${scope.data.name}</a>
              </div>
              <div class="u-mb-" style="font-size: 13px; font-weight: bold;"> ${scope.data.developer_name} </div>
              <div class="u-mb-" style="font-size: 11px; font-weight: normal;"> ${genres} </div>
            </div>
          </div>`);
        }
      }
    };
  })
  .directive('ggCheckbox', function() {
    return {
      restrict: 'E',
      replace: true,
      transclude: true,
      scope: {
        ngModel: '=',
        ngDisabled: '='
      },
      template: `
        <div class="c-check">
           <input type="checkbox" ng-model="ngModel" ng-disabled="ngDisabled" id="checkbox-{{$id}}" class="c-check__input">
           <label for="checkbox-{{$id}}" class="c-check__label">
              <span class="c-check__box">
                <span gg-icon="icon-checkmark" class="c-check__mark"></span>
              </span>
              <span class="c-check__text" ng-transclude ng-if="hasTranscluded"></span>
           </label>
        </div>
      `,
      link: function(scope, element, attrs, ctrl, $transclude){
        $transclude(function(clone){
          if(clone.length){
            scope.hasTranscluded = true;
          }
        });
      }
    };
  })
  .directive('spxToggleButton', function() {
    return {
      restrict: 'E',
      replace: true,
      scope: {
        textForTrue: '=',
        textForFalse: '=',
        ngModel: '='
      },
      template: `<a class="o-btn c-btn c-btn--small c-btn--outlined ng-binding ng-scope" id="" ng-click="to.onClick($event)">{{ text }}</a>`,
      link: function(scope, element, attrs, ctrl, $transclude){
        scope.text = scope.ngModel ? scope.textForTrue : scope.textForFalse;
        element.click(function(event) {
          event.preventDefault();
          scope.$apply(() => {
            scope.ngModel = !scope.ngModel;
            scope.text = scope.ngModel ? scope.textForTrue : scope.textForFalse;
          });
        });
      }
    };
  })
  .directive('spxActionButton', function() {
    return {
      restrict: 'E',
      replace: true,
      scope: {
        disablingCondition: '=',
        show: '=',
        text: '@',
        action: '&'
      },
      template: `<a
        ng-click="!isDisabled() && action()"
        ng-show="{{ show }}"
        ng-class="{'is-disabled': isDisabled() }"
        class="o-btn c-btn c-btn--outlined"> {{ text }} </a>`,
      link: function(scope){
        scope.isDisabled = () => scope.disablingCondition
      }
    };
  })
  .directive('ggCircles', function() {
    return {
      restrict: 'A',
      scope: {
        value: '=',
        text: '='
      },
      template: `
        <div style="width: 152px;"
          ng-circles
          value="'1600'"
          max-value="4444"
          width="10"
          text="'ttttt'"
          colors="['#dadada', '#f9c263']"
          duration="400"
          radius="76"
          wrpClass=""
          textClass="c-segment-preview__description"
          styleWrapper="false"
          styleText="false"
        >
        </div>
         value --> {{ value }}
      `
    };
  })
  .directive('ggCirclesSmall', function() {
    return {
      restrict: 'A',
      scope: {
        value: '='
      },
      template: `
        <div style="width: 22px;" ng-circles value="value||0" width="30" text="null" colors="['#e0e0e0', '#5aafef']"></div>
      `
    };
  })
  .directive('spxViewMoreLess', function($filter) {
    return {
      restrict: 'E',
      scope: {
        textForTrue: '=',
        textForFalse: '=',
        flag: '='
      },
      template: `
        <a ng-if="!flag" class="c-btn--secondary c-btn--secondary__header c-btn--small toggle_link">{{ templateTextForTrue }}</a>
        <a ng-if="flag" class="c-btn--secondary c-btn--secondary__header c-btn--small toggle_link">{{ templateTextForFalse }}</a>
      `,
      link:(scope, element) => {

        scope.templateTextForTrue = scope.textForTrue ? scope.textForTrue : $filter('translate')('view') + ' ' + $filter('translate')('more');
        scope.templateTextForFalse = scope.textForFalse ? scope.textForFalse : $filter('translate')('view') + ' ' + $filter('translate')('less');
        element.click((event) => {
          scope.$apply(() => {
            scope.flag = !scope.flag;
          });
        });
      }
    };
  })
  .directive('ngTableFooter', function() {
    return {
      restrict: 'E',
      replace: true,
      template: `<footer></footer>`,
      link: function(scope, element, attrs, ctrl){
        element.parent().find('[ng-table-pagination]').appendTo(element);
      }
    };
  })
  .directive('jsSubNavToggler', function() {
    return {
      restrict: 'C',
      link: function(scope, element, attrs, ctrl){
        let activeClass = 'is-active';

        element.click(function(event) {
          event.preventDefault();
          element.parent().toggleClass(activeClass);
          element.parents().siblings().removeClass(activeClass);
        });
      }
    };
  })
  .directive('ggToggleClass', function() {
    return {
      restrict: 'A',
      link: function(scope, element, attrs, ctrl){
        element.click(function(event) {
          event.preventDefault();
          element.toggleClass(attrs.ggToggleClass);
        });
      }
    };
  })
  .directive('ggExpand', function() {
    return {
      restrict: 'A',
      link: function(scope, element, attrs, ctrl){
        element.click(function(event) {
          event.preventDefault();
          $(attrs.ggExpand).slideToggle();
          $(window).trigger('nanoscroller:refresh');
        });
      }
    };
  })
  .directive('jsDropdown', function() {
    let activeClass = 'is-active';

    $(document).on('click', function(event) {
      if (!$(event.target).closest('.js-dropdown').length) {
        $('.js-dropdown').removeClass(activeClass);
      }
    });

    return {
      restrict: 'C',
      link: function(scope, element, attrs, ctrl){
        element.click(function(event) {
          if (!$(event.target).closest('a').length) {
            $(this).toggleClass(activeClass);
            $('.js-dropdown').not($(this)).removeClass(activeClass);
          }
        });
      }
    };
  })
  .directive('cBannerCreatorControl', function() {
    return {
      restrict: 'C',
      link: function(scope, element, attrs, ctrl){
        let activeClass = 'is-active';

        element.click(function(event) {
          let targetIsWindow = $(event.target).parents('.c-banner-creator-control__window').length;
          let targetIsDisabled = $(event.target).parents('[disabled]').length;

          if (!targetIsWindow && !targetIsDisabled) {
            element.siblings().removeClass(activeClass);
            element.toggleClass(activeClass);
          }
        });

        element.parents('body').bind('click', (event) => {
          if (!element[0].contains(event.target)) {
            scope.$apply(() => {
              element.removeClass(activeClass);
            });
          }
        });
      }
    };
  })
  .directive('contenteditable', function() {
    return {
      restrict: "A",
      require: "ngModel",
      link: function(scope, element, attrs, ngModel) {
        function read() {
          ngModel.$setViewValue(element.text());
        }

        ngModel.$render = function() {
          element.text(ngModel.$viewValue || "");
        };

        element.bind("blur keyup change", function() {
          scope.$apply(read);
        });

        element[0].focus();
      }
    };
  })
  .directive('ggToggle', function() {
    return {
      restrict: 'A',
      scope: {
        ggToggle: '='
      },
      link: function(scope, element, attrs) {
        let activeClass = 'is-active';

        scope.$watch('ggToggle', (newValue) => {
          element.toggleClass(activeClass, newValue);
        });

        element.bind('click', (event) => {
          scope.$apply(() => {
            scope.ggToggle = !scope.ggToggle;
          });
        });
      }
    };
  })
  .directive('ggInfoIcon', function() {
    let activeClass = 'is-active';
    let tooltipLink = 'a.has-tooltip';

    $(document).on('click', function(event) {
      if (!$(event.target).closest(tooltipLink).length) {
        $(tooltipLink).removeClass(activeClass);
      }
    });

    return {
      restrict: 'E',
      template: `
        <a class="o-btn c-btn c-btn--icon has-tooltip u-ml--">
          <span gg-icon="icon-info"></span>
          <span data-title="{{ text }}" class="c-tooltip c-tooltip--{{placementOrFallback}} c-tooltip--{{size}} {{additionalClass}}"></span>
        </a>`,
      scope: {
        text: '@',
        placement: '@',
        additionalClass: '@'
      },
      link: function(scope, element, attrs) {
        scope.placementOrFallback = scope.placement || 'top';
        scope.size = scope.text.length > 100 ? 'xlarge' : scope.text.length > 30 ? 'large' : 'small';
        element.find(tooltipLink).click(function(event) {
          $(this).toggleClass(activeClass);
          $(tooltipLink).not($(this)).removeClass(activeClass);
        });
      }
    };
  })
  .directive('jsMobilePaddingTop', function() {
    // use it on .o-wrapper to calculate padding top
    // its required for pages with header-secondary
    return {
      restrict: 'C',
      link: function(scope, element, attrs, ctrl){
        function updatePaddingTop() {
          let $primaryHeader = $('.o-layout-primary__header');

          if ($primaryHeader && $primaryHeader.position()) {
            let layoutMainPadding = parseInt($('.o-layout-primary__main').css('padding-top'));
            let headerHeight = $primaryHeader.outerHeight();
            let headerOffset = $primaryHeader.position().top;
            let paddingTop = headerHeight + headerOffset - layoutMainPadding + 16;
            element.css('padding-top', paddingTop);
          }
        }

        $(window).on('resize', function() {
          updatePaddingTop();
        }).trigger('resize');

        setTimeout(function(){
          updatePaddingTop();
        });
      }
    };
  })
  .directive('jsPrimaryMain', function($timeout) {
    return {
      restrict: 'C',
      link: function(scope, element) {
        function mainLayoutPaddingTop() {
          let mainY = ($('.o-layout-primary__header:visible').height() || 0) + ($('.c-nav-primary--mobile:visible').height() || 0);

          $('.c-filters-widget__dialog').css('margin-top', mainY-100);
          element.css('padding-top', mainY);
        }

        $(window).on('resize', () => mainLayoutPaddingTop());

        scope.$on('$stateChangeSuccess', () => {
          $timeout(() => $(window).trigger('resize'));
        });
      }
    };
  })
  .directive('jsNanoscroller', function(){
    return {
      restrict: 'C',
      link: function(scope, element, attrs, ctrl){
        element.nanoScroller({
          nanoClass: 'c-nano',
          paneClass: 'c-nano__scrollbar',
          sliderClass: 'c-nano__thumb',
          contentClass: 'c-nano__content',
          alwaysVisible: true
        });
      }
    };
  })
  .directive('jsNanoscrollerWatch', function($timeout, $window){
    return {
      restrict: 'A',
      scope: {
        jsNanoscrollerWatch: '='
      },
      link: function(scope, element){
        scope.$watch('jsNanoscrollerWatch', () => {
          $timeout(() => element.nanoScroller());
          $timeout(function() {
            var evt = $window.document.createEvent('UIEvents');
            evt.initUIEvent('resize', true, false, $window, 0);
            $window.dispatchEvent(evt);
          });
        });
      }
    };
  })
  .directive('jsGamesWidget', function(){
    return {
      restrict: 'C',
      link: function(scope, element){
        $(window).one('resize', function() {
          let parentHeight = element.parent().height();
          let headerHeight = element.siblings().eq(0).outerHeight();
          element.height(parentHeight - headerHeight);
          element.nanoScroller();
        });
      }
    };
  })
  .directive('jsMapHeader', function(){
    return {
      restrict: 'C',
      link: function(scope, element){
        let $marketplaceWidgets = $('.js-marketplace-widgets');
        $(window).on('scroll', function() {
          let scrollPos = $(window).scrollTop();
          let widgetsPos = element.parent().offset().top;
          widgetsPos -= $('.js-primary-header').outerHeight();

          if (scrollPos > widgetsPos) {
            element.addClass('is-fixed');
            $marketplaceWidgets.css('padding-top', element.outerHeight());
          } else {
            element.removeClass('is-fixed');
            $marketplaceWidgets.css('padding-top', 0);
          }
        });
      }
    };
  })
  .directive('numberSpinner', function(){
    return {
      require: 'ngModel',
      scope: {
        numberSpinner: '='
      },
      link: function(scope, element, attrs, ngModel){
        let step = parseFloat(scope.numberSpinner) || 1;

        function updateViewValue(change) {
          ngModel.$setViewValue(_.round(parseFloat(ngModel.$viewValue||'0') + (change * step),2));
          element.val(ngModel.$viewValue);
          event.preventDefault();
        }

        $(element).keydown((event) => {
          switch(event.which) {
            case 38: // up
              updateViewValue(1);
              break;
            case 40: // down
              updateViewValue(-1);
              break;
            default:
          }
        });

        let plus = $('<span class="c-spinner-button">+</span>').click(() => updateViewValue(1));
        let minus = $('<span class="c-spinner-button">-</span>').click(() => updateViewValue(-1));

        $(element).before(minus);
        $(element).after(plus);
      }
    };
  })
  .directive('integer', function(){
    return {
      require: 'ngModel',
      link: function(scope, element, attrs, ngModel){
        ngModel.$parsers.unshift(function(viewValue){
          return parseInt(viewValue, 10);
        });
      }
    };
  })
  .directive('float', function(){
    return {
      require: 'ngModel',
      link: function(scope, element, attrs, ngModel){
        ngModel.$parsers.unshift(function(viewValue){
          return parseFloat(viewValue);
        });
      }
    };
  })
  .directive('autosizeOnce', function(){
    return {
      link: function(scope, element){
        function adjust() {
          element.css({overflow: 'hidden', height: 'auto'});
          element.css('height', element.prop('scrollHeight'));
        }
        setTimeout(adjust);
      }
    };
  })
  .directive('confirm', function($timeout) {
    return {
      priority: 1,
      scope: {
        ngClick: '&',
        confirm: '@'
      },
      link: function(scope, element) {
        element.unbind("click").bind("click", function ($event) {
          $event.preventDefault();
          $timeout(function () {
            if (window.confirm(scope.confirm)) {
              scope.ngClick();
            }
          });
        });
      }
    };
  })
  .directive('headerGameDevelopersStyling', function($timeout) {
    return {
      link: function(scope, element) {
        if (element.next().is('header-timeframe')) {
          element.addClass('c-header-primary__item u-3/5-large-and-up');
        } else {
          element.addClass('c-header-primary__item c-header-primary__item--fill');
        }
      }
    };
  })
  .directive('overlay', function($document, $compile) {
    return {
      restrict:'E',
      scope: {
        show: '=',
        message: '@'
      },
      link: (scope) => {
        let body = $document.find('body');
        let overlayCompiled = $compile(
          `<div id="body-overlay"
            style="
                position: absolute;
                display: flex;
                flex-direction: column;
                justify-content: center;
                width: 100%;
                height: 100%;
                z-index: 10000;
                top: 0;
                background-color: rgba(111,111,111,0.5);">

               <div id="body-overlay" style="position: fixed; display: flex; align-items: center; justify-content: center; width: 100%; height: 100%; z-index: 10000; top: 0px; left: 0px; background-color: rgba(111, 111, 111, 0.5);" class="ng-scope">
                  <div class="is-open">
                    <img ng-src="images/loading.svg" src="images/loading.svg">
                  </div>
              </div>
          </div>`)(scope);

        scope.$watch('show', (value) => {
          if(value) {
            body.append(overlayCompiled);
            overlayCompiled.css('margin-top', body.scrollTop());
          } else {
            $document.find('#body-overlay').remove();
          }
        });
      }
    };
  })
  .directive('testDirective', function() {
    return {
      template: "",
      controller: function() {console.log("testDirective controller")},
      restrict: 'E',
      controllerAs: 'vm',
      scope: {},
      bindToController: true
    };
  })
  .directive('focusOnCreation', function(){
    return {
      restrict: 'A',
      link: function(scope, element){
        element[0].focus();
      }
    };
  })
  .directive('stickyMe', ['$window', function($window) {
    return {
      restrict: 'A',
      scope: {
        offsetTop: '@'
      },
      link: function($scope, element, attrs) {
        var scroll = function scroll() {
          let offsetTopNumber = parseInt($scope.offsetTop, 10);
          let windowScrollTop = $(window).scrollTop();
          let elementOffsetTop = element.offset().top;
          if(windowScrollTop > elementOffsetTop - offsetTopNumber) {
            element.css({'padding-top': (offsetTopNumber - elementOffsetTop + windowScrollTop) + 'px'});
          } else {
            element.css({'padding-top': '0px'});
          }
        }
        angular.element($window).off('scroll', scroll).on('scroll', scroll);
      }
    };
  }])
  .directive('clickOutsideDetector', ['$document', function ($document) {
    return {
      scope: {
        actionToCall:'&',
        activationFlag:'=',
        skipFirstClick:'@'
      },
      link: function postLink(scope, element, attrs) {
        scope.clicksCounter = 0;
        var onClick = function (event) {
          scope.clicksCounter++;
          var isChild = $(element).has(event.target).length > 0;
          var isSelf = element[0] == event.target;
          var isOutside = !isChild && !isSelf;
          let skipAction = scope.skipFirstClick ? scope.clicksCounter < 2 : false;
          if (isOutside && !skipAction) {
            scope.actionToCall();
          }
        };
        scope.$watch('activationFlag', function(newValue, oldValue) {
          if (newValue) {
            $document.bind('click', onClick);
          } else {
            scope.clicksCounter = 0;
            $document.unbind('click', onClick);
          }
        });
      }
    };
  }]);



/** WEBPACK FOOTER **
 ** ./src/directives/directives.js
 **/